export default __webpack_public_path__ + "static/media/Backspace_Tim.2a5cc745.png";